const ROUTES = {
  ROOT: '/',
  AUTHENTICATE: '/auth',
  NO_ORGANIZATION: '/no-organization',
  MAINTENANCE: '/maintenance',
  NO_PERMISSION: '/no-permission',
  NO_PERMISSION_BALANCE: '/no-permission-balance',
  ORGANIZATION_LEGACY: '/organization',
  FARM_LEGACY: '/farm',
  ITEM: '/item',
  REPORTS: '/reports',
  REPORTS_START: 'start-import',
  REPORTS_LIST_ROOT: 'list',
  REPORTS_LIST: 'list/:docType',
  REPORTS_DETAILS_ROOT: '/reports/details',
  REPORTS_DETAILS: 'details/:idDataImport',
  DASHBOARD: '/dashboard',
  MACHINERY: '/machinery',
  REPORT_GENERAL_LEDGER: '/report-general-ledger',
  ITEM_CATEGORY: '/item-category',
  BALANCE_AI_LIST: '/balance-ai-list',
  NO_COST_RECORDS: '/no-cost-records',
  AG_OPERATION: '/ag-operation',
  AG_OPERATION_CREATE: '/ag-operation-create',
  PURCHASE: '/purchase',
  ACCOUNTS_PAYABLE: '/accounts-payable',
  INVOICE: '/invoice',
  CREATE: 'create',
  EDIT: 'edit/:id',
  SHOW: 'show/:id',
  MATERIAL_CONSUMPTION: '/material-consumption',
  HELP_CENTER: '/help-center',
  SUPPLIER: '/supplier',
  STOCK: '/stock',
  MOVEMENTS_STOCK: 'movements',
  SETTINGS: '/settings',
  FINANCIAL: '/financial',
  FINANCIAL_BUDGET: '/financial-budget',
  SEASON_BUDGET_CREATE: '/season-budget-create',
  FINANCIAL_PRODUCTION: '/financial-production',
  FINANCIAL_MACHINERY: '/financial-machinery',
  MIGRATION: '/migration',
  ELECTRONIC_INVOICE_LINK: '/electronic-invoice-link',
  ELECTRONIC_INVOICE: '/electronic-invoice',
  BANK_ACCOUNT: '/bank-account',
  BALANCE_AI_TERMS_AND_CONDITIONS: '/balance-ai-terms-and-conditions',
  MY_CROPWISE: '/my-cropwise',
  IMPORT: '/import',
  COMMERCIALIZATION: '/commercialization',
  COMMERCIALIZATION_STOCK: '/commercialization/stock',
  COMMERCIALIZATION_MOVEMENTS: '/commercialization/movements',
};

export default ROUTES;
export { ROUTES };
